import RoundImage from 'components/atoms/RoundImage';
import Button from 'components/atoms/students/Button';
import SFormattedMessage from 'components/atoms/sailUI/SFormattedMessage';
import ModalTextContainer from 'components/molecules/students/ModalTextContainer';
import { localStorage as localStorageConstants } from 'constants/index';
import * as qs from 'qs';
import React from 'react';
import { postStartConversation } from 'reducers/conversation';
import styled from '@emotion/styled';
import getAuthToken from 'utils/getAuthToken';
import getMe from 'utils/getMe';
import getPartner from 'utils/getPartner';
import isWebView from 'utils/isWebView';
import resolvePath from 'utils/resolvePath';
import { colors } from 'constants/colors';
import getPreferredName from 'utils/getPreferredName';
export default (props) => {
    const { conversation, myId, path, close } = props;
    const partner = getPartner(conversation, myId);
    const me = getMe(conversation, myId);
    const authToken = getAuthToken();
    const onClick = () => {
        if (!me || !partner)
            return;
        close();
        try {
            if (authToken) {
                postStartConversation(authToken, conversation.id);
            }
        }
        catch (error) {
            // nothing to do
        }
        if (!isWebView()) {
            return;
        }
        const partnerName = getPreferredName(partner.name, partner.preferred_name, partner.type);
        const myName = getPreferredName(me.name, me.preferred_name, me.type);
        const params = {
            end_url: `/students/conversations/${conversation.id}/end`,
            partner_name: partnerName,
            partner_photo_url: partner ? partner.picture_url : '',
            redirect_url: `/students/conversations/${conversation.id}/evaluate`,
            channel_id: conversation.channel_id,
            user_type: 'Student',
            user_id: me ? me.id : 0,
            user_name: myName,
            user_photo: me ? me.picture_url : '',
            partner_id: partner ? partner.id : 0,
            ws_token: localStorage.getItem(localStorageConstants.WEB_SOCKET_TOKEN_KEY) || '',
        };
        window.location.href = `sailapp://call?${qs.stringify(params)}`;
    };
    return (React.createElement(Container, null,
        React.createElement(ModalTextContainer, { heading: 'It is time to start the conversation' }),
        React.createElement(RoundImage, { src: partner ? partner.picture_url : '', size: 176, marginBottom: 32, badge: partner ? (partner.highly_reliable ? 'elder' : null) : null, code: partner ? partner.country_code : '' }),
        React.createElement(Name, null, partner ? partner.name : ''),
        React.createElement(ButtonContainer, null,
            React.createElement(Button, { type: "green", link: isWebView() ? '' : resolvePath.page('students', path), onClick: onClick },
                React.createElement(SFormattedMessage, { id: "talk" }))),
        React.createElement(CloseButton, { onClick: close },
            React.createElement(SFormattedMessage, { id: "conversation_start_modal.close" }))));
};
const Container = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  padding: 40px;
  width: 100%;

  @media (orientation: landscape) {
    height: max-content;
  }
`;
const ButtonContainer = styled.div `
  display: flex;
  justify-content: center;
  margin-top: auto;

  & a {
    padding: 0 1em;
  }
`;
const Name = styled.div `
  margin-bottom: 20px;
  font-size: 40px;
  font-weight: 500;
  text-align: center;
  color: ${colors[405766]};
`;
const CloseButton = styled.button `
  flex: 1;
  margin: 40px auto 0;
  background-color: transparent;
  color: ${colors.blue2};
  font-size: 28px;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
`;
